{
  "common": {
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "saveChanges": "Save changes",
    "saved": "Changes saved",
    "edit": "Edit",
    "copy": "Copy",
    "copied": "Copied",
    "retry": "Try again",
    "loading": "Loading…",
    "never": "Never"
  },
  "time": {
    "justNow": "just now"
  },
  "units": {
    "turns": "turns",
    "messages": "messages",
    "chars": "chars",
    "days": "days",
    "docs": "docs"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "roles": {
    "owner": "Owner",
    "admin": "Admin",
    "member": "Member",
    "ownerHint": "Full control, including billing and deleting the organization",
    "adminHint": "Manages members, settings and every resource",
    "memberHint": "Uses the portals they have been given access to"
  },
  "perms": {
    "management": "Studio & management",
    "managementHint": "Build agents, connect tools and change organization settings.",
    "chat": "Chat",
    "chatHint": "Talk to agents one-on-one.",
    "workplace": "Workplace",
    "workplaceHint": "Work with agent teams in shared rooms.",
    "tasks": "Tasks",
    "tasksHint": "Create, assign and follow up on tasks and projects."
  },
  "auth": {
    "signOut": "Sign out",
    "signedOut": "You have been signed out"
  },
  "errors": {
    "network": "Can't reach the server. Check your connection and try again.",
    "rateLimited": "Too many requests. Please wait a moment and try again.",
    "unauthorized": "Your session has expired. Please sign in again.",
    "forbidden": "You don't have permission to do this.",
    "server": "Something went wrong on our side. Please try again in a moment.",
    "unknown": "Something unexpected happened.",
    "loadFailed": "Couldn't load this",
    "offlineTitle": "You're offline",
    "forbiddenTitle": "No access",
    "notFoundTitle": "Not found",
    "copyFailed": "Couldn't copy to the clipboard",
    "pageNotFoundTitle": "Page not found",
    "pageNotFoundDescription": "The page you're looking for doesn't exist or has moved.",
    "backHome": "Back to home"
  },
  "validation": {
    "required": "This field is required",
    "minLength_one": "Use at least {{count}} character",
    "minLength_other": "Use at least {{count}} characters",
    "maxLength_one": "Use at most {{count}} character",
    "maxLength_other": "Use at most {{count}} characters",
    "min": "Must be {{min}} or more",
    "max": "Must be {{max}} or less",
    "minItems_one": "Select at least {{count}} item",
    "minItems_other": "Select at least {{count}} items",
    "email": "Enter a valid email address",
    "url": "Enter a valid URL, starting with https://",
    "format": "This format isn't valid",
    "number": "Enter a number"
  },
  "form": {
    "required": "required",
    "none": "None",
    "selectPlaceholder": "Select…",
    "searchPlaceholder": "Search…",
    "noMatches": "No matches",
    "removeTag": "Remove {{tag}}",
    "unsaved": "You have unsaved changes",
    "discard": "Discard",
    "saveChanges": "Save changes"
  },
  "confirm": {
    "typeToConfirm": {
      "before": "Type",
      "after": "to confirm."
    },
    "irreversible": "This action cannot be undone."
  },
  "secret": {
    "title": "Copy this now — it won't be shown again",
    "description": "Store it somewhere safe, like a password manager or your deployment's secret store. If you lose it, create a new one.",
    "copy": "Copy secret",
    "show": "Show secret",
    "hide": "Hide secret"
  },
  "markdown": {
    "image": "Image",
    "loadImage": "Load image “{{label}}” from {{host}}"
  },
  "table": {
    "search": "Search…",
    "clearSearch": "Clear search",
    "columns": "Columns",
    "toggleColumns": "Visible columns",
    "actions": "Actions",
    "rowActions": "Row actions",
    "empty": "Nothing here yet",
    "noResults": "No results",
    "noResultsHint": "Nothing matches “{{query}}”.",
    "showing": "{{from}}–{{to}} of {{total}}",
    "rowsPerPage": "Rows per page",
    "page": "Page {{page}} of {{pages}}",
    "previousPage": "Previous page",
    "nextPage": "Next page"
  },
  "theme": {
    "label": "Theme",
    "light": "Light",
    "dark": "Dark",
    "system": "System"
  },
  "palette": {
    "label": "Colour palette",
    "zacht": "Soft",
    "meierij": "Meierij white",
    "leisteen": "Slate",
    "salie": "Sage",
    "zand": "Sand",
    "mist": "Haze"
  },
  "language": {
    "label": "Language"
  },
  "pwa": {
    "install": "Install app",
    "updateTitle": "A new version is available",
    "updateDescription": "Reload to get the latest improvements.",
    "reload": "Reload",
    "later": "Later"
  },
  "nav": {
    "main": "Main navigation",
    "home": "Home",
    "menu": "Menu",
    "openMenu": "Open navigation",
    "breadcrumbs": "Breadcrumbs",
    "collapsePanel": "Collapse sidebar",
    "expandPanel": "Expand sidebar",
    "skipToContent": "Skip to content",
    "modes": {
      "chat": "Chat",
      "workplace": "Workplace",
      "tasks": "Tasks",
      "knowledge": "Knowledge",
      "studio": "Studio",
      "insights": "Insights",
      "settings": "Settings"
    },
    "modeDescriptions": {
      "chat": "Talk to your agents",
      "workplace": "Rooms where agent teams work together",
      "tasks": "Tasks, boards and projects",
      "knowledge": "Documents and search your agents can use",
      "studio": "Build agents, connect models and tools",
      "insights": "Runs, costs and live monitoring",
      "settings": "Organization, members and your account"
    },
    "groups": {
      "build": "Build",
      "models": "Models",
      "connect": "Connect",
      "automate": "Automate",
      "quality": "Quality",
      "organization": "Organization",
      "account": "Account",
      "platform": "Platform"
    },
    "items": {
      "newChat": "New chat",
      "chatHistory": "History",
      "rooms": "Rooms",
      "allTasks": "All tasks",
      "board": "Board",
      "projects": "Projects",
      "documents": "Documents",
      "knowledgeSearch": "Search & index",
      "agents": "Agents",
      "teams": "Teams",
      "skills": "Skills",
      "models": "Models",
      "providers": "Providers",
      "mcp": "MCP servers",
      "connectors": "Connectors",
      "endpoints": "Endpoints",
      "automations": "Automations",
      "schedules": "Schedules",
      "evals": "Evaluations",
      "runs": "Runs",
      "costs": "Costs",
      "monitor": "Live monitor",
      "general": "General",
      "members": "Members",
      "apiTokens": "API tokens",
      "audit": "Audit log",
      "profile": "Profile",
      "organizations": "Organizations",
      "platformUsers": "Platform users"
    }
  },
  "command": {
    "title": "Command palette",
    "description": "Search pages and actions",
    "placeholder": "Type a command or search…",
    "empty": "No results found.",
    "open": "Open command palette",
    "trigger": "Search or jump to…",
    "switchTo": "Switch to {{name}}",
    "togglePanel": "Toggle sidebar",
    "theme": "Theme: {{theme}}",
    "palette": "Colour palette: {{palette}}",
    "language": "Language: {{language}}",
    "groups": {
      "organizations": "Organizations",
      "actions": "Actions",
      "preferences": "Preferences"
    },
    "footer": {
      "navigate": "Navigate",
      "open": "Open",
      "close": "Close"
    }
  },
  "shortcuts": {
    "title": "Keyboard shortcuts",
    "description": "Move around without touching the mouse.",
    "general": "General",
    "navigation": "Navigation",
    "palette": "Open the command palette",
    "togglePanel": "Toggle the sidebar",
    "help": "Show this overview",
    "goTo": "Go to {{place}}"
  },
  "userMenu": {
    "label": "Account menu",
    "profile": "Profile",
    "sessions": "Signed-in devices",
    "platformAdmin": "Platform administration"
  },
  "login": {
    "title": "Sign in",
    "heading": "Welcome back",
    "subheading": "Sign in to your workspace to continue.",
    "username": "Username or email",
    "usernamePlaceholder": "you@company.com",
    "password": "Password",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "submit": "Sign in",
    "signingIn": "Signing in…",
    "retryIn": "Try again in {{seconds}}s",
    "expired": "Your session has ended. Sign in again to pick up where you left off.",
    "help": "Forgot your password? Ask an administrator of your organization to reset it.",
    "hintFocus": "focus username",
    "hintSubmit": "sign in",
    "errors": {
      "failedTitle": "Sign-in failed",
      "failed": "We couldn't sign you in. Please try again.",
      "invalidTitle": "Incorrect username or password",
      "invalid": "Check your details and try again. Usernames are not case-sensitive.",
      "rateLimitedTitle": "Too many attempts",
      "rateLimited": "For your security, sign-in is paused for a moment.",
      "rateLimitedWait": "For your security, sign-in is paused. Try again in {{seconds}} seconds.",
      "networkTitle": "Can't reach the server",
      "network": "Check your connection, or ask your administrator whether the platform is running.",
      "forbiddenTitle": "Access denied",
      "forbidden": "Your account can't sign in right now."
    },
    "brand": {
      "headline": "Agents that work together, on your terms.",
      "subline": "Build, run and orchestrate AI agents and agent teams on infrastructure you control.",
      "pillars": {
        "secure": "Secure",
        "private": "Private",
        "open": "Model-agnostic"
      }
    },
    "flow": {
      "title": "incident-review · team run",
      "live": "live",
      "agents": {
        "planner": "Planner",
        "researcher": "Researcher",
        "analyst": "Analyst",
        "writer": "Writer"
      },
      "planner": "split the request into three steps and assigned owners.",
      "researcher": "pulled 14 log excerpts and 2 related incidents.",
      "analyst": "traced the root cause to a config change at 09:42.",
      "writer": "drafted the summary with a timeline and next actions.",
      "done": "Flow complete — ready for your review."
    }
  },
  "profile": {
    "title": "Profile",
    "description": "Your personal details, preferences, password and signed-in devices.",
    "saved": "Profile updated",
    "platformAdmin": "Platform admin",
    "details": {
      "title": "Personal details",
      "description": "How you appear to others in this platform.",
      "displayName": "Display name",
      "email": "Email",
      "emailPlaceholder": "you@company.com",
      "username": "Username",
      "memberSince": "Member since",
      "lastLogin": "Last sign-in"
    },
    "preferences": {
      "title": "Preferences",
      "description": "Applied on this device right away. Your language follows you everywhere.",
      "themeHint": "Match your system or pick a fixed appearance.",
      "languageHint": "Used for the interface and saved to your profile."
    },
    "password": {
      "title": "Password",
      "description": "Use a long, unique password. Changing it signs out your other devices.",
      "current": "Current password",
      "new": "New password",
      "confirm": "Confirm new password",
      "rules": "At least 10 characters, not only numbers.",
      "mismatch": "The passwords don't match",
      "notNumeric": "Can't be only numbers",
      "submit": "Update password",
      "changed": "Password updated. Other devices have been signed out.",
      "signsOutOthers": "You'll stay signed in here; every other session ends."
    },
    "sessions": {
      "title": "Signed-in devices",
      "description": "Devices that are currently signed in to your account.",
      "current": "This device",
      "device": "{{browser}} on {{os}}",
      "unknownIp": "Unknown location",
      "lastActive": "Active",
      "signedIn": "Signed in",
      "revoke": "Sign out other devices",
      "revokeTitle": "Sign out all other devices?",
      "revokeDescription_one": "{{count}} other device will be signed out immediately.",
      "revokeDescription_other": "{{count}} other devices will be signed out immediately.",
      "revoked": "Other devices have been signed out"
    }
  },
  "tenants": {
    "title": "Organizations",
    "description": "All organizations you belong to. Each browser tab can work in a different one.",
    "search": "Search organizations…",
    "current": "Current",
    "deactivated": "Deactivated",
    "platformAccess": "Platform access",
    "switchTo": "Switch to this organization",
    "switched": "Switched to {{name}}",
    "created": "Created {{name}}",
    "archived": "{{name}} has been deactivated",
    "reactivated": "{{name}} is active again",
    "deleted": "{{name}} has been deleted",
    "columns": {
      "name": "Organization",
      "kind": "Type",
      "role": "Your role",
      "members": "Members",
      "status": "Status",
      "created": "Created"
    },
    "kind": {
      "organization": "Organization",
      "organizationHint": "Shared workspace for a team or company",
      "personal": "Personal",
      "personalHint": "A private sandbox just for you"
    },
    "form": {
      "name": "Name",
      "namePlaceholder": "Acme Corp",
      "slug": "Slug",
      "slugHint": "Optional. Lowercase letters, digits and dashes; generated from the name when empty.",
      "slugEditHint": "Used in URLs and API calls. Changing it can break existing integrations.",
      "slugInvalid": "Use lowercase letters, digits and dashes only",
      "kind": "Type"
    },
    "create": {
      "title": "New organization",
      "description": "Organizations keep agents, data and members separate. You'll become its owner.",
      "submit": "Create organization"
    },
    "switcher": {
      "label": "Switch organization",
      "heading": "Organizations",
      "none": "No organization",
      "deactivated": "Deactivated",
      "settings": "Organization settings",
      "all": "All organizations",
      "create": "New organization"
    },
    "archive": {
      "title": "Deactivate {{name}}?",
      "description": "Members can no longer open this organization and its automations stop. Nothing is deleted; you can reactivate it at any time.",
      "confirm": "Deactivate"
    },
    "reactivate": {
      "title": "Reactivate {{name}}?",
      "description": "Members regain access and automations resume.",
      "confirm": "Reactivate"
    },
    "delete": {
      "title": "Delete {{name}} permanently?",
      "description": "This removes the organization and everything in it for every member.",
      "confirm": "Delete organization",
      "willDelete": "The following will be permanently deleted",
      "nothing": "This organization has no data besides its settings."
    },
    "entities": {
      "agent_runs": "Agent runs",
      "agents": "Agents",
      "chat_sessions": "Chat sessions",
      "connectors": "Connectors",
      "eval_suites": "Eval suites",
      "kb_documents": "Documents",
      "mcp_servers": "MCP servers",
      "memberships": "Members",
      "model_providers": "Model providers",
      "models": "Models",
      "projects": "Projects",
      "rooms": "Rooms",
      "schedules": "Schedules",
      "skills": "Skills",
      "tasks": "Tasks",
      "teams": "Teams"
    },
    "empty": {
      "title": "No organizations yet",
      "description": "Create an organization to start building agents with your team."
    }
  },
  "orgSettings": {
    "title": "Organization",
    "description": "Settings that apply to everyone in {{name}}.",
    "saved": "Organization settings saved",
    "onThisPage": "On this page",
    "readOnly": "Only owners and admins can change these details.",
    "defaultSlug": "The default organization's slug can't be changed.",
    "notSet": "Not set",
    "auto": "Automatic",
    "modelPickerHint": "Models are managed in Studio → Models.",
    "providerPickerHint": "Providers are managed in Studio → Providers.",
    "agentPickerHint": "Agents are managed in Studio → Agents.",
    "lastUpdated": "Last updated",
    "sections": {
      "general": {
        "title": "General",
        "description": "Name, address and type of this organization."
      },
      "conversation": {
        "title": "Conversations & memory",
        "description": "How much history agents keep and when long conversations are summarised."
      },
      "knowledge": {
        "title": "Knowledge & embeddings",
        "description": "How documents are turned into searchable vectors."
      },
      "files": {
        "title": "Files & uploads",
        "description": "Size limits, quotas and allowed file types."
      },
      "externalChat": {
        "title": "External chat API",
        "description": "Let other systems talk to an agent through the public chat endpoint."
      },
      "evals": {
        "title": "Evaluations & monitoring",
        "description": "Models and thresholds used to judge agent quality."
      },
      "observability": {
        "title": "Observability",
        "description": "Links to the tracing and error tools your team uses."
      },
      "danger": {
        "title": "Danger zone",
        "description": "Irreversible and destructive actions."
      }
    },
    "files": {
      "chatAndProjects": "Chat & projects",
      "connectors": "Connectors"
    },
    "fields": {
      "timezone": "Time zone",
      "timezoneHint": "Used for schedules, reports and dates shown to agents.",
      "summaryModel": "Summary model",
      "summaryTriggerTurns": "Summarise every",
      "summaryTriggerTurnsHint": "Older turns are folded into a rolling summary.",
      "historyMaxMessages": "Messages kept in history",
      "historyRecentTurnsFull": "Recent turns kept verbatim",
      "historyRecentTurnsFullHint": "The newest turns are never summarised.",
      "maxToolResponseChars": "Max tool output kept",
      "sessionFactsMaxChars": "Session facts budget",
      "sessionFactsUpdate": "Update session facts while summarising",
      "sessionFactsUpdateHint": "Keeps a short list of key facts about the conversation up to date.",
      "embeddingProvider": "Embedding provider",
      "embeddingModel": "Embedding model",
      "embeddingDimensions": "Dimensions",
      "embeddingDimensionsHint": "Leave empty to use the model's default.",
      "embeddingBatchSize": "Batch size",
      "chatUploadMax": "Chat upload limit",
      "projectFileMax": "Project file limit",
      "projectQuota": "Project storage quota",
      "projectExtensions": "Allowed project file types",
      "connectorFileMax": "Connector file limit",
      "connectorQuota": "Connector storage quota",
      "connectorRetention": "Keep connector files for",
      "connectorRetentionHint": "0 keeps files forever.",
      "connectorExtensions": "Allowed connector file types",
      "extensionsHint": "Press Enter or comma after each extension.",
      "externalChatEnabled": "Enable the external chat endpoint",
      "externalChatEnabledHint": "Requests must use an API token with the chat scope.",
      "externalChatAgent": "Agent answering external chats",
      "evalJudgeModel": "Judge model",
      "monitorModel": "Live monitor model",
      "evalParallelism": "Parallel eval cases",
      "evalParallelismHint": "Higher is faster but uses more provider capacity.",
      "evalRegressionThreshold": "Regression alert threshold",
      "evalRegressionThresholdHint": "Alert when a suite's score drops by more than this.",
      "observabilityUrl": "Tracing dashboard URL",
      "observabilityUrlHint": "Shown as a link next to runs, e.g. your Logfire project.",
      "sentrySlug": "Sentry organization"
    },
    "danger": {
      "archiveTitle": "Deactivate organization",
      "archiveDescription": "Temporarily block access and pause automations. You can undo this.",
      "archive": "Deactivate",
      "deleteTitle": "Delete organization",
      "deleteDescription": "Permanently delete this organization, its agents, conversations and files.",
      "delete": "Delete…",
      "defaultProtected": "The default organization is protected and can't be deactivated or deleted."
    }
  },
  "members": {
    "title": "Members",
    "description": "People with access to {{name}} and what they can use.",
    "invite": "Invite member",
    "search": "Search members…",
    "allRoles": "All roles",
    "you": "(you)",
    "noAccess": "No portals",
    "platformAdmin": "Platform admin",
    "added": "{{name}} has been added",
    "updated": "{{name}} has been updated",
    "removed": "{{name}} has been removed",
    "remove": "Remove from organization",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "columns": {
      "member": "Member",
      "user": "User",
      "role": "Role",
      "access": "Access",
      "status": "Status",
      "lastActive": "Last active"
    },
    "removeConfirm": {
      "title": "Remove {{name}}?",
      "description": "They lose access to this organization immediately. Their account stays on the platform."
    },
    "create": {
      "description": "Add an existing user by username, or create a new account by also setting a password.",
      "submit": "Add member"
    },
    "edit": {
      "title": "Edit {{name}}",
      "description": "Change their role, access and account status."
    },
    "empty": {
      "title": "Just you so far",
      "description": "Invite colleagues to build and use agents together."
    },
    "form": {
      "username": "Username",
      "usernameHint": "If this user already exists, they're added to this organization.",
      "usernameInvalid": "Use letters, digits and . _ @ + - only",
      "displayName": "Display name",
      "email": "Email",
      "password": "Password",
      "passwordHint": "Required only when creating a new account. At least 10 characters.",
      "resetPassword": "Reset password",
      "resetPasswordHint": "Leave empty to keep the current password.",
      "accessHeading": "Access",
      "role": "Role",
      "selfRoleHint": "You can't change your own role.",
      "portals": "Portals",
      "allAgents": "All chat agents",
      "allAgentsHint": "Can chat with every agent that allows chat.",
      "allowedAgents": "Allowed agent IDs",
      "allowedAgentsHint": "A visual agent picker arrives with Studio → Agents.",
      "allowedAgentsPlaceholder": "e.g. 12, 15",
      "accountHeading": "Account",
      "active": "Active",
      "activeHint": "Inactive members can't sign in to this organization.",
      "platformAdmin": "Platform administrator",
      "platformAdminHint": "Full access to every organization and platform settings."
    }
  },
  "apiTokens": {
    "title": "API tokens",
    "description": "Tokens let scripts, CI and other systems call the API on behalf of this organization.",
    "create": "Create token",
    "createDescription": "Give the token a recognisable name and only the scopes it needs.",
    "created": "Token created",
    "createdTitle": "“{{name}}” is ready",
    "createdDescription": "Use it as a Bearer token in the Authorization header.",
    "done": "I've copied the token",
    "revoke": "Revoke",
    "revoked": "“{{name}}” has been revoked",
    "service": "Service",
    "neverUsed": "Never used",
    "expired": "Expired",
    "noExpiry": "No expiry",
    "usage": "Send the token in the Authorization header:",
    "revokeConfirm": {
      "title": "Revoke “{{name}}”?",
      "description": "Anything using this token stops working immediately."
    },
    "columns": {
      "name": "Name",
      "scopes": "Scopes",
      "owner": "Owner",
      "lastUsed": "Last used",
      "expires": "Expires",
      "created": "Created"
    },
    "empty": {
      "title": "No API tokens",
      "description": "Create a token to call the API from scripts or other systems."
    },
    "form": {
      "name": "Name",
      "namePlaceholder": "e.g. Nightly report job",
      "scopes": "Scopes",
      "scopesRequired": "Select at least one scope",
      "expiry": "Expires after",
      "days_one": "{{count}} day",
      "days_other": "{{count}} days",
      "never": "Never",
      "service": "Service token",
      "serviceHint": "Not tied to your account; keeps working if you leave.",
      "submit": "Create token"
    },
    "scopes": {
      "management": {
        "label": "Management",
        "description": "Agents, models, tools and settings."
      },
      "chat": {
        "label": "Chat",
        "description": "Send messages to agents."
      },
      "workplace": {
        "label": "Workplace",
        "description": "Rooms and agent teams."
      },
      "tasks": {
        "label": "Tasks",
        "description": "Create and update tasks and projects."
      },
      "kbSearch": {
        "label": "Knowledge search",
        "description": "Search the knowledge base only."
      },
      "all": {
        "label": "Full access",
        "description": "Everything this organization allows. Use sparingly.",
        "short": "full access"
      }
    },
    "mcp": {
      "title": "MCP access for Claude",
      "description": "Operate this platform from Claude (Code or Desktop): set up organizations (members, providers, models, agents, integrations, knowledge, chat endpoints, evals), inspect runs and projects, and hotfix prompts or parameters. Every change goes through the normal API, is audited and creates agent revisions.",
      "create": "Create MCP token",
      "endpoint": "Endpoint:",
      "tokenName": "Claude MCP",
      "dialogDescription": "A personal token for the /mcp endpoint.",
      "points": {
        "actsAsYou": "Platform admins only. Acts as you in any organization (pick one per tool call).",
        "onlyMcp": "Only works at /mcp; the REST API rejects it.",
        "audited": "Changes are audited under your name; revoke it here at any time."
      },
      "createdTitle": "Your MCP token",
      "createdDescription": "Copy the token now — it is shown only once. Then add the server to Claude with one of the snippets below.",
      "snippets": {
        "claudeCode": "Claude Code — run once",
        "mcpJson": "Claude Code — .mcp.json (project) or ~/.claude.json",
        "desktop": "Claude Desktop — claude_desktop_config.json (needs Node.js)"
      }
    }
  },
  "audit": {
    "title": "Audit log",
    "description": "Who changed what, and when. Secrets are always masked.",
    "search": "Search people, objects or changes…",
    "allEntities": "All objects",
    "allActions": "All actions",
    "allOrganizations": "All organizations",
    "clearFilters": "Clear filters",
    "from": "From date",
    "to": "To date",
    "entry": "Audit entry",
    "entryId": "Entry",
    "entityId": "Object ID",
    "ip": "IP address",
    "changes": "Changes",
    "noChanges": "No field changes were recorded for this event.",
    "fieldsChanged_one": "{{count}} field",
    "fieldsChanged_other": "{{count}} fields",
    "columns": {
      "time": "When",
      "actor": "Who",
      "action": "Action",
      "entity": "Object",
      "changes": "Changes"
    },
    "diff": {
      "field": "Field",
      "before": "Before",
      "after": "After"
    },
    "actions": {
      "create": "Created",
      "update": "Updated",
      "delete": "Deleted",
      "access": "Accessed",
      "login": "Signed in",
      "logout": "Signed out",
      "execute": "Ran"
    },
    "entities": {
      "tenant": "Organization",
      "membership": "Member",
      "user": "User",
      "settings": "Settings",
      "api_token": "API token",
      "agent": "Agent",
      "model": "Model",
      "model_provider": "Provider",
      "mcp_server": "MCP server",
      "skill": "Skill"
    },
    "empty": {
      "title": "No activity yet",
      "description": "Changes to settings, members and resources will show up here."
    },
    "emptyFiltered": {
      "title": "No matching events",
      "description": "Try a different search or widen the date range."
    }
  },
  "platformUsers": {
    "title": "Platform users",
    "description": "Every account on this platform, across all organizations.",
    "search": "Search users…",
    "create": "Create user",
    "createDescription": "Create an account. Add it to organizations from their Members page.",
    "edit": "Edit {{name}}",
    "editDescription": "Update account details, reset the password or change platform access.",
    "created": "{{name}} has been created",
    "updated": "{{name}} has been updated",
    "user": "User",
    "grantAdmin": "Make platform admin",
    "revokeAdmin": "Remove platform admin",
    "passwordRequired": "A password is required for new accounts",
    "activeHint": "Inactive users can't sign in anywhere.",
    "selfHint": "You can't change this for your own account.",
    "empty": "No users",
    "columns": {
      "user": "User",
      "role": "Platform role",
      "status": "Status",
      "organizations": "Orgs",
      "lastLogin": "Last sign-in",
      "created": "Created"
    },
    "stats": {
      "total": "Users",
      "active": "Active",
      "admins": "Platform admins"
    }
  }
}
